import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const caretDown: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M7.844-6.844c.101.094.156.211.156.344q0 .204-.14.344l-3.5 3.5A.5.5 0 0 1 4-2.5a.44.44 0 0 1-.344-.156l-3.5-3.5A.44.44 0 0 1 0-6.5q0-.201.14-.344A.5.5 0 0 1 .5-7h7c.133 0 .25.055.344.156m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 7)"
    />
  ),
  svgProps: {
    height: "4.5",
    width: "8",
  }
};

export const caretRight: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M4.36-5.36q.14.16.14.36 0 .204-.14.344l-3.5 3.5A.5.5 0 0 1 .5-1a.52.52 0 0 1-.36-.14A.52.52 0 0 1 0-1.5v-7q0-.201.14-.344A.5.5 0 0 1 .5-9q.2 0 .36.14zm0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 9)"
    />
  ),
  svgProps: {
    height: "8",
    width: "4.5",
  }
};

export const caretUp: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M7.86-2.86Q8-2.7 8-2.5a.5.5 0 0 1-.156.36A.47.47 0 0 1 7.5-2h-7a.52.52 0 0 1-.36-.14A.52.52 0 0 1 0-2.5q-.001-.2.156-.36l3.5-3.5A.47.47 0 0 1 4-6.5q.2 0 .36.14zm0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 6.5)"
    />
  ),
  svgProps: {
    height: "4.5",
    width: "8",
  }
};